import React, { Component } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChevronRight,
  faChevronLeft,
  faBars,
  faSearch,
  faImage,
  faBook,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faWrench,
  faTimes,
  faCog,
  faFire,
  faSort,
  faHeart,
  faClock,
  faSync,
  faArrowLeft,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faChevronRight,
  faChevronLeft,
  faBars,
  faSearch,
  faImage,
  faBook,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faWrench,
  faTimes,
  faCog,
  faFire,
  faSort,
  faHeart,
  faClock,
  faSync,
  faArrowLeft,
  faArrowRight
)

class Icon extends Component {
  constructor(props) {
    super(props)

    this.state = {
      renderable: false
    }
  }

  componentDidMount() {
    this.setState({
      renderable: true
    })
  }

  render() {
    if (!this.state.renderable) {
      return ''
    }

    switch (this.props.type) {
      case 'flag':
        if (!this.props.icon) {
          return ''
        }

        return <div className={`flag flag-${this.props.icon}`} />
      default:
        return <FontAwesomeIcon icon={this.props.icon} />
    }
  }
}

Icon.propTypes = {
  icon: PropTypes.string,
  style: PropTypes.string,
  type: PropTypes.string
}

export default Icon
